import React, { useMemo } from "react";
import {
  AlertNotification,
  H2,
  Popup,
  PopupHeader,
  XIcon,
} from "@commonsku/styles";
import { BASE_ZINDEX } from "../../../popup-factory";
import styled from "styled-components";

interface ExportToShipStationStatusPopupProps {
  errorMessage: string | null;
  handleShowPopup: (popup: string, errorMessage?: string | null) => void;
  getStoresError?: boolean;
}

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
`;

const ExportToShipStationStatusPopup = ({
  errorMessage,
  handleShowPopup,
  getStoresError,
}: ExportToShipStationStatusPopupProps) => {
  const alertNotificationBody = useMemo(() => {
    if (getStoresError) {
      return (
        <span>
          We couldn’t export this order to ShipStation because your ShipStation
          API secret and key pair is missing or invalid.{" "}
          <a href="/admin_settings_new.php">Click here</a> to configure them
          correctly in the admin settings and try again.
        </span>
      );
    }
    if (errorMessage) {
      return errorMessage;
    }
    return "Checkouts are being exported. You will be notified via email once all checkouts have been exported. It is safe to navigate away from this page.";
  }, [errorMessage, getStoresError]);

  return (
    <>
      <Popup
        overlayZIndex={BASE_ZINDEX + 100}
        zIndex={BASE_ZINDEX + 200}
        style={{ width: 575, height: 192, borderRadius: 10 }}
        header={
          <PopupHeader
            style={{ padding: 0, alignItems: "center", marginBottom: 16 }}
          >
            <H2
              style={{
                fontSize: 24,
                lineHeight: "40px",
                margin: "0px",
              }}
              className="title"
            >
              {getStoresError
                ? "Export to ShipStation Failed"
                : errorMessage
                ? "Exporting Checkouts Failed"
                : "Exporting Checkouts"}
            </H2>
            <XIcon
              style={{ cursor: "pointer" }}
              size="large"
              onClick={() => handleShowPopup("")}
            />
          </PopupHeader>
        }
      >
        <StyledContainer>
          <AlertNotification
            alertType={errorMessage || getStoresError ? "error" : "neutral"}
            style={{ height: 80, alignItems: "center" }}
          >
            {alertNotificationBody}
          </AlertNotification>
        </StyledContainer>
      </Popup>
    </>
  );
};

export default ExportToShipStationStatusPopup;
